import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImagePlus, Upload } from 'lucide-react';

import CommonDropzone from '../../../components/common-dropzone/CommonDropzone';
import { useMediaStudio } from '../../context/MediaStudioContext';

import scss from './MediaStudioEmptyState.module.scss';

function MediaStudioEmptyState() {
  const { t } = useTranslation('mediaStudio');
  const { files } = useMediaStudio();

  const handleDrop = (droppedFiles) => {
    const file = droppedFiles?.[0];
    if (file) {
      files.openImage(file);
    }
  };

  return (
    <div className={scss.wrapper}>
      <CommonDropzone className={scss.dropzone} onDrop={handleDrop}>
        {() => (
          <div className={scss.content}>
            <div className={scss.iconWrap}>
              <Upload size={32} strokeWidth={1.5} />
            </div>
            <h2 className={scss.title}>{t('emptyTitle')}</h2>
            <p className={scss.hint}>{t('emptyHint')}</p>
            <span className={scss.action}>
              <ImagePlus size={16} />
              {t('openImage')}
            </span>
          </div>
        )}
      </CommonDropzone>
    </div>
  );
}

export default MediaStudioEmptyState;
